module.exports = __webpack_public_path__ + "static/media/mysticdiva_1366.b9d6fe8f.jpg";